import React, { Component } from 'react';
import * as Styles from './Styles';
import Button from '../../../components/button/Button';
import { gotoPage } from '../../../utils/gotoPage';
import { Routing } from '../../../core/Routing';

type Props = {};

type State = {};

class Duties extends Component<Props, State> {
	state = {};

	renderSection1Content = () => {
		return (
			<>
				<Styles.BoldFont style={{ textAlign: 'center' }}>
					ubezpieczenie OC oraz koszty ochrony prawnej
				</Styles.BoldFont>
				<p>
					Zgodnie z § 11 Warunków Ubezpieczenia odpowiedzialności
					cywilnej z tytułu wykonywania czynności zawodowych (B), kod:
					OC/OW060/2108 ubezpieczony ma następujące obowiązki w
					przypadku zajścia wypadku ubezpieczeniowego:
				</p>
				<Styles.BoldFont>
					Obowiązek zgłoszenia wypadku, roszczenia, wszczęcia
					postępowania, doręczenia orzeczenia:
				</Styles.BoldFont>
				<p>
					Ubezpieczony jest zobowiązany do poinformowania
					ubezpieczyciela o zajściu wypadku niezwłocznie, lecz nie
					później niż w terminie do 7 dni od uzyskania o nim
					wiadomości. W razie złożenia bezpośrednio do ubezpieczonego
					roszczenia o odszkodowanie, wszczęcia w związku z wypadkiem
					postępowania przygotowawczego lub postępowania sądowego,
					ubezpieczony zobowiązany jest do poinformowania
					ubezpieczyciela o tym fakcie niezwłocznie, nie później niż w
					terminie do 5 dni od uzyskania stosownych informacji.
					Powyższy obowiązek jest niezależny od obowiązku zgłoszenia
					wypadku. Dodatkowo ubezpieczony jest zobowiązany doręczyć
					ubezpieczycielowi orzeczenie sądu w sprawach, o których mowa
					powyżej, w terminie umożliwiającym wniesienie środka
					odwoławczego, tj. nie później niż na 3 dni przed możliwością
					wniesienia środka odwoławczego lub środka zaskarżenia
					orzeczenia lub postanowienia.{' '}
				</p>
				<Styles.BoldFont>
					Obowiązek zmniejszenia rozmiaru szkody:{' '}
				</Styles.BoldFont>
				<p>
					W razie zajścia wypadku, ubezpieczony jest zobowiązany użyć
					dostępnych mu środków w celu zmniejszenia rozmiarów szkody.{' '}
				</p>
				<Styles.BoldFont>
					Obowiązek współpracy, udzielania pełnomocnictw:{' '}
				</Styles.BoldFont>
				<p>
					Ubezpieczony jest zobowiązany podjąć aktywną współpracę z
					ubezpieczycielem w celu wyjaśnienia wszelkich okoliczności i
					przyczyn powstania szkody oraz ustalenia jej rozmiaru, a
					także ustalenia zasadności zgłaszanych roszczeń.
					Ubezpieczony jest zobowiązany stosować się do zaleceń
					ubezpieczyciela, udzielając stosownych informacji oraz
					niezbędnych pełnomocnictw ubezpieczycielowi lub osobie przez
					niego wskazanej, w tym w szczególności pełnomocnictw
					procesowych.
				</p>
				<Styles.BoldFont>
					Zaniechanie uznania roszczenia:{' '}
				</Styles.BoldFont>
				<p>
					W razie zgłoszenia roszczenia o naprawienie szkody
					ubezpieczony ma obowiązek zaniechania działań zmierzających
					do zaspokojenia roszczeń osoby trzeciej, ich uznania bądź
					zawarcia z nią ugody – do czasu uzyskania pisemnej zgody
					ubezpieczyciela.{' '}
				</p>
				<Styles.BoldFont>
					Zawiadomienie o przestępstwie:{' '}
				</Styles.BoldFont>
				<p>
					Jeżeli okoliczności wskazują, że szkoda jest wynikiem
					przestępstwa, ubezpieczony jest zobowiązany powiadomić
					policję lub inne właściwe organy ścigania.
				</p>
				<Styles.BoldFont>
					Zabezpieczenie roszczeń regresowych:
				</Styles.BoldFont>
				<p>
					Ubezpieczony jest zobowiązany dostarczyć ubezpieczycielowi
					wszelkie informacje i dokumenty niezbędne dla skutecznego
					dochodzenia przez ubezpieczyciela roszczeń odszkodowawczych
					(regresowych) od osób trzecich oraz dokonać czynności
					niezbędnych dla skutecznego dochodzenia powyższych roszczeń
					przez ubezpieczyciela.{' '}
				</p>
				<Styles.BoldFont>
					Przeciwdziałanie zagrożeniom:{' '}
				</Styles.BoldFont>
				<p>
					Ubezpieczony jest zobowiązany do wyeliminowania szczególnych
					zagrożeń, których usunięcia – stosownie do okoliczności –
					ubezpieczyciel domagał się w pismach wystosowanych do
					ubezpieczającego lub ubezpieczonego; za szczególne
					zagrożenia uważa się zwłaszcza przyczyny powstania szkody.
				</p>
			</>
		);
	};

	renderSection2Content = () => {
		return (
			<>
				<Styles.BoldFont style={{ textAlign: 'center' }}>
					ubezpieczenie NNW
				</Styles.BoldFont>
				<p>
					Zgodnie z § 35 oraz § 36 Ogólnych Warunków Ubezpieczenia
					Biznes & Podróż z dnia 1 sierpnia 2021 r. (kod:
					PAT/OW071/2108) ubezpieczony ma następujące obowiązki w
					przypadku zajścia wypadku ubezpieczeniowego:
				</p>
				<ul>
					<li>
						poddać się leczeniu i stosować się do zaleceń mających
						na celu złagodzenie skutków wypadku,
					</li>
					<li>
						zwolnić lekarzy, u których leczył się przed zaistnieniem
						wypadku objętego ochroną ubezpieczeniową, z obowiązku
						zachowania tajemnicy lekarskiej oraz wyrazić zgodę na
						udostępnienie dokumentacji z leczenia,
					</li>
					<li>
						zwolnić publiczne i niepubliczne zakłady opieki
						zdrowotnej oraz Zakład Ubezpieczeń Społecznych z
						obowiązku zachowania tajemnicy oraz wyrazić zgodę na
						udostępnienie dokumentacji medycznej,
					</li>
					<li>
						poddać się badaniu przez lekarzy wskazanych przez ERGO
						Hestię lub ewentualnej obserwacji klinicznej,
					</li>
					<li>
						podjąć aktywną współpracę z ERGO Hestią w celu
						wyjaśnienia wszelkich okoliczności powstania wypadku i
						ustalenia jego następstw,
					</li>
					<li>
						umożliwić ERGO Hestii dokonanie czynności niezbędnych do
						ustalenia okoliczności powstania wypadku, zasadności i
						wysokości roszczenia oraz udzielić w tym celu pomocy i
						wyjaśnień.
					</li>
				</ul>
				<p>
					W przypadku niedopełnienia przez ubezpieczonego tych
					obowiązków, ERGO Hestia może odmówić wypłaty odszkodowania w
					całości lub w odpowiedniej części, w zależności od tego w
					jakim stopniu niedopełnienie tych obowiązków miało wpływ na
					ustalenie przyczyny wypadku, okoliczności zdarzenia lub
					wysokości odszkodowania.
				</p>
				<p>
					W razie śmierci ubezpieczonego uprawniony obowiązany jest
					dostarczyć do ERGO Hestii dokumenty niezbędne do ustalenia
					zasadności roszczenia, przez które rozumie się w
					szczególności wyciąg z aktu zgonu oraz dokumenty
					stwierdzające pokrewieństwo lub powinowactwo uprawnionego z
					ubezpieczonym.
				</p>
				<p>
					Ubezpieczony obowiązany jest dostarczyć ERGO Hestii
					dokumenty, niezbędne do rozpatrzenia wniosku o wypłatę
					świadczenia, w tym w szczególności:
				</p>
				<ul>
					<li>
						diagnozy lekarskie i inne dokumenty stwierdzające
						przyczyny wypadku i zakres udzielonej pomocy medycznej,
					</li>
					<li>
						rachunki za opłaconą pomoc medyczną lub dotyczące innych
						kosztów objętych zakresem ubezpieczenia.
					</li>
				</ul>
				<p>
					Dokumenty te ubezpieczony zobowiązany jest zgromadzić i
					dostarczyć ERGO Hestii na własny koszt.
				</p>
				<p>
					ERGO Hestia zastrzega sobie prawo do weryfikacji dokumentów
					przedłożonych przez ubezpieczonego oraz zasięgnięcia opinii
					specjalistów.
				</p>
			</>
		);
	};

	renderSection3Content = () => {
		return (
			<>
				<Styles.BoldFont style={{ textAlign: 'center' }}>
					zabezpiecz się przed nieoczekiwanym!
				</Styles.BoldFont>
				<p>
					Jako ratownik WOPR doskonale zdajesz sobie sprawę, że woda
					to żywioł pełen niespodzianek. Ubezpieczenie OC, kosztów
					ochrony prawnej oraz NNW to Twój osobisty ratunek w razie
					niespodziewanych zdarzeń.
				</p>
				<p>
					Skorzystaj z formularza, aby szybko obliczyć wysokość
					składki ubezpieczeniowej, która odpowiada Twoim potrzebom.
				</p>
				<Button
					Icon={<></>}
					label="sprawdź składkę"
					onClick={() => gotoPage(Routing.main.start)}
					style={{ margin: '40px auto 0' }}
				/>
			</>
		);
	};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.HeadingFont>
					obowiązki ubezpieczonego i tryb postępowania
				</Styles.HeadingFont>
				<Styles.HeadingLowerFont>
					w razie wystąpienia szkody lub nieszczęśliwego wypadku
					należy mieć na uwadze poniższe postanowienia
				</Styles.HeadingLowerFont>
				<Styles.ContentContainer>
					{this.renderSection1Content()}
				</Styles.ContentContainer>
				<Styles.ContentContainer style={{ margin: '10px auto' }}>
					{this.renderSection2Content()}
				</Styles.ContentContainer>
				<Styles.ContentContainer>
					{this.renderSection3Content()}
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

export default Duties;
